import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import { ACTION_BACK_PATH, HEALTH_RECORDS_BIRTH_INFORMATION_PATH } from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';

const BirthInformationPage = lazy(() => import('@features/HealthRecords/BirthInformation/pages/BirthInformationPage'));

export const BIRTH_INFORMATION_ROUTES = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <BirthInformationPage />,
    displayTitle: () => 'Birth Information',
    pageType: PageType.PRIVATE,
    path: HEALTH_RECORDS_BIRTH_INFORMATION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.birthInformation,
  },
];
